define('views/register/register',[
	'backbone',
	'views/_base/baseview',
	'text!views/register/register.html',
	'text!views/register/register_rxsavings.html',
	'text!views/register/register_proteus.html',
	'views/shared/form/form_component',
	'models/user/register/register',
	'models/user/register/eligibility',
], function (
	Backbone,
	BaseView,
	Template,
	RxSavingsTemplate,
	ProteusTemplate,
	FormComponent,
	RegisterModel,
	EligibilityModel
) {
	'use strict';

	return BaseView.extend({
		className: 'register-container',
		tagName: 'div',
		isRender: true,
		events: {},

		initialize: function (options) {
			options = options || {};

			this.elementName = options.elementName;

			this.site_version = pf.getContent('version.id');

			this.registration_form_content = pf.getContent(
				'register.content.form.standard'
			);

			var form_id = enums.registrationId.regular,
				form_options = {
					id: enums.registrationId.social,
					depth: 2,
				};

			if (this.site_version == enums.siteVersion.bcbsaz) {
				// form_options.set_id = enums.registrationSetId.bcbsaz;

				if (pf.fb_pixel) {
					pf.fb_pixel.viewContent();
				}
			} else if (this.site_version == enums.siteVersion.bcbsla) {
				// var form_id = enums.registrationSetId.bcbsla;
				// form_options.set_id = enums.registrationSetId.bcbsla;
			} else if (this.site_version == enums.siteVersion.rxsavings) {
				// var form_id = enums.registrationSetId.standard;

				form_options.depth = 1;
				form_options.depth_id = 2;
				form_options.set_id =
					enums.registrationSetId.regular_subscriber_id_email;
			} else if (this.site_version == enums.siteVersion.proteus) {
				form_options.depth = 1;
				form_options.depth_id = 2;
				form_options.set_id =
					enums.registrationSetId.regular_subscriber_id_email;
			} else if (this.site_version == enums.siteVersion.bcbssc) {
				// var form_id = enums.registrationSetId.standard;

				form_options.depth = 1;
				form_options.depth_id = 2;
				form_options.set_id =
					enums.registrationSetId.regular_subscriber_id_email;
			} else if (this.site_version == enums.siteVersion.csnp) {
				// var form_id = enums.registrationSetId.standard;

				form_options.depth = 1;
				form_options.depth_id = 2;
				form_options.set_id =
					enums.registrationSetId.regular_subscriber_id_email;
			} else if (this.site_version == enums.siteVersion.centene) {
				form_options.depth = 1;
				form_options.depth_id = 2;
				form_options.set_id =
					enums.registrationSetId.regular_subscriber_id_email;
			} else if (this.site_version == enums.siteVersion.bcbskc) {
				form_options.depth = 1;
				form_options.depth_id = 2;
				form_options.set_id =
					enums.registrationSetId.regular_subscriber_id_email;
			} else {
				// form_options.set_id = enums.registrationSetId.regular;
			}

			this.campaign_code = options.IA;

			this.registration = pf.getFeatureById(form_id, form_options);

			this.registration_form = null;

			this.response = null;

			this.eligibility_required = false;
			this.eligibility_status = null;
			this.eligibility_guid = null;
			this.eligibility_request_not_found = 0;

			this.status_interval_clear = true;
			this.status_invterval_count = 0;

			if (
				!isSunsetting() &&
				this.site_version !== enums.siteVersion.payforward
			) {
				startPanoScrollAnimator('.register-content-container', 0.25);
			}

			// console.log('register initialize', this, form_options);

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this,
				template = null;

			if (this.site_version == enums.siteVersion.rxsavings) {
				template = _.template(RxSavingsTemplate);
			} else if (this.site_version == enums.siteVersion.proteus) {
				template = _.template(ProteusTemplate);
			} else {
				template = _.template(Template);
			}

			this.$el.addClass(pf.getContent('version.name')).html(template());

			this.addRegistrationForm();

			return this;
		},

		loadData: function () {},

		addRegistrationForm: function () {
			var that = this,
				form_fields = pf.getContent('register.content.form.standard.fields'),
				button_data = pf.getContent(
					'register.content.form.standard.button_component'
				),
				route = pf.getContent('register.content.form.standard.route');

			if (_.isObject(this.registration)) {
				this.registration_form = new FormComponent({
					elementName: '.js-register-form',
					button_data: button_data,
					route: route,
					// fields     : form_fields,
					// form_type  : enums.formType.standard,

					feature: this.registration,
					content_fields: form_fields,
					form_type: enums.formType.features,
					validated: function (fields, confirm) {
						// console.log('registration_form validated:',fields,confirm);

						that.registerUser();
					},
					success: function (end) {
						// console.log('addRegistrationForm success:',end);
						// Route to next step or home
						that.registrationSuccess();
					},
					error: function (errors) {
						// console.log('addRegistrationForm error:',errors);
						that.registrationError(errors);
					},
				});

				if (this.campaign_code) {
					this.registration_form.updateFieldValue(
						enums.formComponentTypes.invite_code,
						this.campaign_code
					);
				}

				if (this.site_version != enums.siteVersion.bcbssc) {
					this.registration_form.updateFieldValue(
						enums.formComponentTypes.marketing,
						true
					);
				}

				if (this.site_version != enums.siteVersion.csnp) {
					this.registration_form.updateFieldValue(
						enums.formComponentTypes.marketing,
						true
					);
				}

				if (this.site_version != enums.siteVersion.centene) {
					this.registration_form.updateFieldValue(
						enums.formComponentTypes.marketing,
						true
					);
				}

				if (this.site_version != enums.siteVersion.bcbskc) {
					this.registration_form.updateFieldValue(
						enums.formComponentTypes.marketing,
						true
					);
				}
			}
		},

		removeToken: function () {
			var name = 'token';

			if (window.localStorage) {
				localStorage.setItem(name, null);
			} else {
				$.removeCookie(name, { path: '/' });
			}
		},

		registerUser: function () {
			var that = this;

			if (
				this.site_version == enums.siteVersion.bcbssc ||
				this.site_version == enums.siteVersion.rxsavings ||
				this.site_version == enums.siteVersion.proteus ||
				this.site_version == enums.siteVersion.csnp ||
				this.site_version == enums.siteVersion.centene
			) {
				this.register_model = new RegisterModel({
					instanceURL: pf.userURL + 's/Wellness',
				});

				this.removeToken();
			} else {
				this.register_model = new RegisterModel();
			}

			/*

                Social Registration Data Object:
                    - FirstName
                    - LastName
                    - Email
                    - Password
                    - ZipCode
                    - DOB
                    - ssn4
                    - ReferralCode
                    - cbUnsubscribe


                // Register
                this.EGUID = options.EGUID;
                this.instanceURL = options.instanceURL;
                this.FirstName = options.FirstName;
                this.MiddleName = options.MiddleName;
                this.LastName = options.LastName;
                this.Email = options.Email;
                this.City = options.City;
                this.State = options.State;
                this.ZipCode = options.ZipCode;
                this.Gender = options.Gender;
                this.Optional = options.OP;
                this.Website = options.WS;
                this.CampaignCode = options.CGUID;
                this.Unsubscribe = options.U;
                this.InvitationCode = options.IC;
                this.InvitationCodeResponse = options.ICR;
                this.ReferralCode = options.RC;
                this.UserGUID = options.UG;
                this.IAM = options.IsAnthemMember;


            */

			// var data = this.$(".registrationForm").serializeObject();
			var data = this.registration_form.getFieldValues();

			// Is any of this needed?
			data.IsAnthemMember = '0';
			data.IsMobileApp = pf.session.inApp == true ? true : false; // What is this?
			data.IsMobile = pf.isMobile() == true ? true : false;

			// data.Website = (data.Website !== "") ? true : false;
			// data.IsAnthemMember = data.IsAnthemMember !== "0" ? true : false;
			this.register_model.set(data);

			var invite_field = this.registration_form.getField(
				enums.formComponentTypes.invite_code
			);

			if (invite_field) {
				if (invite_field.eligibility_required == true) {
					this.sendEligibilityRequest(data);
				} else if (invite_field.empty) {
					this.checkEligibilityStatus(function () {
						if (that.eligibility_required) {
							that.sendEligibilityRequest(data);
						} else {
							that.checkToken();
						}
					});
				} else {
					this.checkToken();
				}
			} else {
				if (this.campaign_code) {
					data.ReferralCode = this.campaign_code;
				}

				if (
					this.eligibility_required == true &&
					this.site_version != enums.siteVersion.bcbssc &&
					this.site_version != enums.siteVersion.rxsavings &&
					this.site_version != enums.siteVersion.proteus &&
					this.site_version != enums.siteVersion.csnp &&
					this.site_version != enums.siteVersion.centene &&
					this.site_version != enums.siteVersion.bcbskc
				) {
					this.sendEligibilityRequest(data);
				} else {
					this.checkToken();
				}
			}
		},

		checkEligibilityStatus: function (callback) {
			var that = this;

			$.ajax({
				url: pf.lookupsURL + '/ReferralCode2/0',
				type: 'GET',
				async: false,
				contentType: 'application/json',
				success: function (response) {
					if (response.Flag2 === true) {
						that.eligibility_required = true;
					} else {
						that.eligibility_required = false;
					}

					if (_.isFunction(callback)) {
						callback();
					}
				},
				error: function (error) {
					that.eligibility_required = false;

					if (_.isFunction(callback)) {
						callback();
					}
				},
			});
		},

		sendEligibilityRequest: function (data) {
			var that = this;
			this.eligibility_guid = createReferenceNumber();

			data.appendEGUID = false;
			data.EGUID = this.eligibility_guid;

			delete data.Email;
			delete data.Password;

			this.user_eligibility = new EligibilityModel(data);

			this.user_eligibility.save(null, {
				success: function (modelStatus, respStatus, options) {
					that.startStatusInterval(data);
				},
				error: function (modelStatus, respStatus, options) {
					if (respStatus.status == 200 || respStatus.status == 202) {
						that.startStatusInterval(data);
					} else {
						if (_.isFunction(that.registration_form.acknowledgedValidation)) {
							that.registration_form.acknowledgedValidation(false);
						}
					}
				},
			});
		},

		startStatusInterval: function (data) {
			var that = this;

			this.eligibility_status = setInterval(function () {
				if (that.status_invterval_count < 24) {
					if (that.status_interval_clear) {
						that.status_interval_clear = false;

						// Call the polling endpoint
						that.checkEligibility(data);
					}
				} else {
					clearInterval(that.eligibility_status);

					if (_.isFunction(that.registration_form.acknowledgedValidation)) {
						that.registration_form.acknowledgedValidation(false);
					}
				}
			}, 5000);
		},

		checkEligibility: function (data) {
			var that = this;

			this.user_eligibility_get = new EligibilityModel();

			this.user_eligibility_get.set(data);

			this.user_eligibility_get.set({
				EGUID: this.eligibility_guid,
				appendEGUID: true,
			});

			this.user_eligibility_get.fetch({
				success: function (modelStatus, respStatus, options) {
					that.status_invterval_count = that.status_invterval_count + 1;

					// 202: Processing, 200: Good
					if (options.xhr.status == 200) {
						clearInterval(that.eligibility_status);

						// Add the EGUID before the account is created
						that.register_model.set({ EGUID: that.eligibility_guid });

						if (
							respStatus.hasOwnProperty('success') &&
							respStatus.success == true
						) {
							that.checkToken();
						} else {
							// TBD: If the success flag isn't true then something may have gone wrong
							that.checkToken();
						}
					} else if (options.xhr.status == 202) {
						that.status_interval_clear = true;
					} else if (options.xhr.status != 202) {
						clearInterval(that.eligibility_status);
					}
				},
				error: function (modelStatus, respStatus, options) {
					// TODO: Replace content with final content and add to content files
					var title = 'You are not eligible',
						body = JSON.parse(respStatus.responseText).ErrorMessage;

					var cancelEligibilityCheck = function (titleTxt, bodyTxt) {
						// Cancel Interval
						clearInterval(that.eligibility_status);

						// Temporary message
						if (_.isFunction(that.registration_form.updateErrorMessage)) {
							that.registration_form.updateErrorMessage(bodyTxt);
						}

						if (_.isFunction(that.registration_form.acknowledgedValidation)) {
							that.registration_form.acknowledgedValidation(false);
						}
					};

					switch (respStatus.status) {
						case 404:
							// Record wasn't found so try up to 3 times to allow network latency to catch up

							if (that.eligibility_request_not_found >= 3) {
								cancelEligibilityCheck(title, body);
							} else {
								that.status_interval_clear = true;
								that.eligibility_request_not_found =
									that.eligibility_request_not_found + 1;
							}
							break;
						case 406:
							// Not Eligible
							cancelEligibilityCheck(title, body);
							break;
						case 500:
							// Something unexplained happened
							cancelEligibilityCheck(title, body);
							break;
						default:
							// If some other error
							cancelEligibilityCheck(title, body);
							break;
					}
				},
			});
		},

		checkToken: function () {
			var that = this;

			gAnalytics('SocialSignUp', 'Continue', 'Clicked');

			if (this.site_version == enums.siteVersion.bcbsaz) {
				if (pf.fb_pixel) {
					pf.fb_pixel.formSubmission();
				}
			}

			if (pf.session.get('_csrf')) {
				this.createAccount();
			} else {
				refreshAuth(function () {
					that.createAccount();
				});
			}
		},

		createAccount: function () {
			var that = this;
			// data = this.registration_form.getFieldValues();

			// Commented out for testing before we apply this fix
			// Get the field values again just in case they were lost during eligibilty check
			// this.register_model.set(data);

			this.register_model.save(null, {
				success: function (model, resp, options) {
					// console.log('registerUser success',model,resp,options);

					that.response = resp;

					store.removeStoreItem(enums.modelsEnum.ReferralCode);
					store.removeStoreItem(enums.modelsEnum.SignUpEmailAddress);

					store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, {
						Data: 1,
					});
					store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 1 });

					// //---------------------palash new reg change------------------------
					// pf.session.set('dob', $('#dob').val());
					// pf.session.set('ssn4', $('#ssn4').val());
					// //---------------------palash new reg change------------------------

					if (resp) {
						pf.session.saveToken(resp);

						pf.session.ZipCodeLive = resp.U.ZCL;
					}

					that.registration_form.acknowledgedValidation(true);
				},
				error: function (model, resp, options) {
					// console.log('registerUser error',model,resp,options);

					switch (resp.status) {
						case 200:
							if (!pf.session.inApp) {
								pf.show(new verificationView({ resp: resp }), '#mainRegion');
							} else {
								pf.session.saveToken(resp);

								store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, {
									Data: 1,
								});
								store.setStoreItem(enums.modelsEnum.IsRegistration, {
									Data: 1,
								});

								if (
									_.isFunction(that.registration_form.acknowledgedValidation)
								) {
									that.registration_form.acknowledgedValidation(true);
								}
							}

							break;
						case 400:
							// console.log('Registration Failure 400:',resp);

							var msg = jQuery.parseJSON(resp.responseText);

							if (
								_.isFunction(that.registration_form.updateErrorMessage) &&
								_.isObject(msg)
							) {
								that.registration_form.updateErrorMessage(msg.Message);
							}

							if (_.isFunction(that.registration_form.acknowledgedValidation)) {
								that.registration_form.acknowledgedValidation(false);
							}

							break;
						case 401:
							if (_.isFunction(that.registration_form.updateErrorMessage)) {
								that.registration_form.updateErrorMessage(
									'Registration failed'
								);
							}

							if (_.isFunction(that.registration_form.acknowledgedValidation)) {
								that.registration_form.acknowledgedValidation(false);
							}

							break;
						case 409:
							if (_.isFunction(that.registration_form.updateErrorMessage)) {
								that.registration_form.updateErrorMessage(
									pf.getContent(
										'register.content.form.standard.error.non_match'
									)
								);
							}

							if (_.isFunction(that.registration_form.showInlineErrorMessage)) {
								that.registration_form.showInlineErrorMessage();
							}

							// Show the fields that are potentially incorrect (MemberID, Last Name, and DOB)
							that.registration_form.showFieldError(
								enums.formComponentTypes.member_id,
								true
							);
							that.registration_form.showFieldError(
								enums.formComponentTypes.last_name,
								true
							);
							that.registration_form.showFieldError(
								enums.formComponentTypes.date_of_birth,
								true
							);

							if (_.isFunction(that.registration_form.acknowledgedValidation)) {
								that.registration_form.acknowledgedValidation(false);
							}

							break;
						default:
							// if(resp){
							//     pf.session.saveToken(resp);
							//     store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, { Data: 1 });
							//     store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 1 });
							// }

							// // TODO: Make routing dynamic based on client
							// if(_.isFunction(that.registration_form.acknowledgedValidation)){
							//     that.registration_form.acknowledgedValidation(true);
							// }

							if (_.isFunction(that.registration_form.acknowledgedValidation)) {
								that.registration_form.acknowledgedValidation(false);
							}

							break;
					}
				},
			});
		},

		registrationSuccess: function () {
			var that = this;

			if (
				this.site_version == enums.siteVersion.bcbssc ||
				this.site_version == enums.siteVersion.rxsavings ||
				this.site_version == enums.siteVersion.proteus ||
				this.site_version == enums.siteVersion.csnp ||
				this.site_version == enums.siteVersion.centene ||
				this.site_version == enums.siteVersion.bcbskc
			) {
				if (this.registration_form_content.route) {
					pf.navigate(this.registration_form_content.route);
				}
			} else {
				// Temporary, make the member application self sustainable
				var product = enums.cardTypes.VirtualCard;

				pf.require('views/register/financial', null, null, true, function () {
					require(['views/register/financial'], function (FinancialRegView) {
						pf.show(
							new FinancialRegView({
								elementName: '#mainRegion',
								product: product,
								isBcbsla: that.response.OIWP,
							})
						);
					});
				});

				// pf.require("views/user/register/financial/memberapplication", null, null, true, function (){
				//     require(["views/user/register/financial/memberapplication"], function (FinancialRegView){
				//         pf.show(new FinancialRegView({ elementName: "#mainRegion", product: product, isBcbsla: resp.OIWP }));
				//     });
				// });
			}
		},

		registrationError: function (a) {
			// console.log('registrationError',a);
		},

		close: function () {
			endPanoScrollAnimator();
		},
	});
});

